import React from 'react'
import { FormControl, Grid, InputLabel, MenuItem, Select, Typography } from '@material-ui/core'
import { ModalConfirmacao } from 'components'

const justificativasPrivacidade = ['Segredo de Justiça', 'Investigação Sigilosa', 'Proteção à Vítima', 'Dados Sensíveis', 'Ordem Judicial']

export const ModalPublicarExame = (props) => {
  const {
    aberto,
    onClose,
    onConfirm,
    processando,
    isPrivateSelect,
    setIsPrivateSelect,
    justificativaPrivacidade,
    setJustificativaPrivacidade
  } = props

  const isDisabled = isPrivateSelect && !justificativaPrivacidade

  return (
    <ModalConfirmacao
      aberto={aberto}
      onClose={onClose}
      onConfirm={onConfirm}
      processando={processando}
      disabled={isDisabled}
      titulo="Publicar Exame"
      confirmarLabel="Publicar"
      maxWidth="sm"
    >
      <div style={{ marginTop: '15px' }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FormControl fullWidth variant="outlined">
              <InputLabel shrink id="privacidade-label">Nível de Privacidade</InputLabel>
              <Select
                labelId="privacidade-label"
                value={isPrivateSelect}
                onChange={(e) => setIsPrivateSelect(e.target.value)}
                notched
                label="Nível de Privacidade"
              >
                <MenuItem value={false}>Público</MenuItem>
                <MenuItem value={true}>Privado</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          {isPrivateSelect && (
            <Grid item xs={12}>
              <FormControl fullWidth variant="outlined">
                <InputLabel shrink id="justificativa-label">Justificativa de Privacidade</InputLabel>
                <Select
                  labelId="justificativa-label"
                  value={justificativaPrivacidade}
                  onChange={(e) => setJustificativaPrivacidade(e.target.value)}
                  notched
                  label="Justificativa de Privacidade"
                >
                  <MenuItem value="">
                    <em>Selecione uma justificativa</em>
                  </MenuItem>
                  {justificativasPrivacidade.map((just) => (
                    <MenuItem key={just} value={just}>{just}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          )}
        </Grid>
      </div>
    </ModalConfirmacao>
  )
}
